import { useMemo } from 'react';
import { TradeInSortingField } from '../../../api/types';

const useSortOrder = sort =>
    useMemo(
        () => ({
            appDateSort: sort.field === TradeInSortingField.ApplicationDate ? sort.orderValue : undefined,
            identifierSort: sort.field === TradeInSortingField.Identifier ? sort.orderValue : undefined,
            vehicleNoSort: sort.field === TradeInSortingField.VehicleNo ? sort.orderValue : undefined,
            vehicleMakeSort: sort.field === TradeInSortingField.VehicleMake ? sort.orderValue : undefined,
            vehicleModelSort: sort.field === TradeInSortingField.VehicleModel ? sort.orderValue : undefined,
            manufacturingYearSort: sort.field === TradeInSortingField.ManufacturingYear ? sort.orderValue : undefined,
            selectedDealerSort: sort.field === TradeInSortingField.SelectedDealer ? sort.orderValue : undefined,
            offerPriceSort: sort.field === TradeInSortingField.OfferPrice ? sort.orderValue : undefined,
            statusSort: sort.field === TradeInSortingField.Status ? sort.orderValue : undefined,
        }),
        [sort]
    );

export default useSortOrder;
